<div class="panel">
    <div class="detail-page-card">
        <div class="detail-page-card-title">
            {{ "widgetConfiguration.headerSettingsTitle" | t }}
        </div>
        <div class="detail-page-card-body padded">
            <div class="form-group">
                <cerrix-checkbox
                    data-uiid="widgetConfigurationHideHeaderCheckbox"
                    [label]="'widgetConfiguration.hideHeaderLabel' | t"
                    [(value)]="config.customConfig.hideHeader"
                ></cerrix-checkbox>
            </div>

            <div class="form-group">
                <label>{{ "widgetConfiguration.customTitleLabel" | t }}</label>
                <cerrix-textfield
                    [placeholder]="catalogKey(config.title) | t"
                    [(ngModel)]="config.customConfig.customTitle"
                    [disabled]="config.customConfig.hideHeader"
                ></cerrix-textfield>
            </div>

            <div class="form-group">
                <label>{{ "widgetConfiguration.customIconLabel" | t }}</label>
                <cerrix-icon-picker
                    [(value)]="config.customConfig.customIcon"
                    [disabled]="config.customConfig.hideHeader"
                ></cerrix-icon-picker>
            </div>
        </div>
    </div>

    @if (graphItems.length > 0 || legendItems.length > 1) {
        <div class="detail-page-card">
            <div class="detail-page-card-title">
                {{ "widgetConfiguration.graphSettingsTitle" | t }}
            </div>
            <div class="detail-page-card-body padded">
                @if (graphItems.length > 0) {
                    <div class="form-group">
                        <label>{{ "widgetConfiguration.graphTypeLabel" | t }}</label>
                        <ng-select
                            [items]="graphItems"
                            (change)="filterChanged()"
                            bindLabel="Value"
                            bindValue="Key"
                            [(ngModel)]="config.customConfig.graphType"
                        >
                        </ng-select>
                    </div>
                }

                @if (legendItems.length > 1) {
                    <div class="form-group">
                        <label>{{ "widgetConfiguration.legendTypeLabel" | t }}</label>
                        <ng-select
                            [items]="legendItems"
                            (change)="filterChanged()"
                            bindLabel="Value"
                            bindValue="Key"
                            [(ngModel)]="config.customConfig.legendType"
                        >
                        </ng-select>
                    </div>
                }
            </div>
        </div>
    }

    @if (widgetSettings && widgetSettings.length > 0) {
        <div class="detail-page-card">
            <div class="detail-page-card-title">
                {{ "widgetConfiguration.widgetSettingsTitle" | t }}
            </div>
            <div class="detail-page-card-body padded">
                @for (field of widgetSettings; track field) {
                    <div class="form-group">
                        <generic-field-editor
                            [row]="config.customConfig.filterValues"
                            [field]="field"
                            [editEnabled]="true"
                            [hideFillers]="true"
                            [selfInit]="true"
                            (valueChanged)="filterChanged()"
                        ></generic-field-editor>
                    </div>
                }
            </div>
        </div>
    }

    @if (dataFilters && dataFilters.length > 0) {
        <div class="detail-page-card">
            <div class="detail-page-card-title">
                {{ "widgetConfiguration.dataFilteringTitle" | t }}
            </div>
            <div class="detail-page-card-body padded">
                @if (config.globalFilterKeys && config.globalFilterKeys.length > 0) {
                    <div class="form-group global-filter-group">
                        <cerrix-checkbox
                            data-uiid="widgetConfigurationEnableGlobalFilteringCheckbox"
                            [label]="'widgetConfiguration.enableGlobalFilteringLabel' | t"
                            [(value)]="config.customConfig.globalFilterEnabled"
                        ></cerrix-checkbox>
                        @if (globalFilterFieldNames) {
                            @let globalFilteringTooltip =
                                'widgetConfiguration.globalFilteringDescription'
                                    | t: { filters: globalFilterFieldNames };
                            <i class="fas fa-info-circle ms-2" [matTooltip]="globalFilteringTooltip"></i>
                        }
                    </div>
                }

                @for (field of dataFilters; track field) {
                    <div class="form-group">
                        <generic-field-editor
                            [row]="config.customConfig.filterValues"
                            [field]="field"
                            [editEnabled]="true"
                            [hideFillers]="true"
                            [selfInit]="true"
                            (valueChanged)="filterChanged()"
                        ></generic-field-editor>
                    </div>
                }
            </div>
        </div>
    }
</div>
